import angular from 'angular';

import CommunicationModule from './communication';
import PaymentModule from './payment';
import StorageModule from './storage';

import NavigationService from './navigation.service';
import DiagnosticsService from './diagnostics.service';

export default angular
    .module('common.service', [
        CommunicationModule.name,
        PaymentModule.name,
        StorageModule.name
    ])
    .service('navigationService', NavigationService)
    .service('diagnosticsService', DiagnosticsService);



// WEBPACK FOOTER //
// ./src/common/service/index.js